import ValidateModule from "./ValidateModule";

import type { IEventChannel } from "../model/Models";
import type AjaxRequestBroker from "../AjaxRequestBroker";
import type {ApiOpts} from "@esWebAPI/es/model/Models";
import type CacheModule from "./CacheModule";

const es = global.es;

/**
 * @class AsyncTasksModule
 */
export default class AsyncTasksModule {
    private eventChannel: IEventChannel;
    private rqBroker: AjaxRequestBroker;
    private resourceName: string;
    private cache: CacheModule;

    constructor(eventChannel: IEventChannel, rqBroker: AjaxRequestBroker, resourceName: string, cache: CacheModule) {
        this.eventChannel = eventChannel;
        this.rqBroker = rqBroker;
        this.resourceName = resourceName;
        this.cache = cache;

        this.getForGeoMap = this.getForGeoMap.bind(this);
    }

    /**
     * Get the tasks associated with the geoMap
     * 
     * @return a jquery deferred object resolved when the request has completed
     */
    getForGeoMap(geoMapId: number, opts?: ApiOpts) {
        if (!ValidateModule.checkId(geoMapId)) {
            return es.util.deferred.rejected();
        }

        const url = es.api.getURL(this.resourceName) + "/" + geoMapId;
        // TO BE CORRECT SHOULD USE NO CACHE!!! Since this is to be called once on page load, should be ok, and loads from Preloader
        return this.cache.doGet(this.rqBroker, this.resourceName, url, geoMapId, opts);
    }
}
